//main thread
import Worker from "worker-loader!./worker.js";
import * as Comlink from "comlink";

export const { calculateCart } = Comlink.wrap(new Worker());
